import type { FreightClass } from '@fv/models'

interface Result {
  freightClass: FreightClass
  density: number
  volume: number
}
interface Opts {
  height?: number | string
  length?: number | string
  quantity?: number | string
  weight?: number | string
  width?: number | string
}

export type FreightClassEstimateResult = Result | null

export const calculateFreightClassEstimate = (
  opts: Opts,
): FreightClassEstimateResult => {
  const { height, length, quantity, weight, width } = opts
  if (
    !height ||
    isNaN(Number(height)) ||
    !length ||
    isNaN(Number(length)) ||
    !quantity ||
    isNaN(Number(quantity)) ||
    !weight ||
    isNaN(Number(weight)) ||
    !width ||
    isNaN(Number(width))
  )
    return null

  const volume = getVolume(opts)
  const density = getDensity(opts, volume)

  if (density <= 0 || volume <= 0) return null

  return {
    freightClass: getClassEstimate(density),
    density,
    volume,
  }
}

const getVolume = (opts: Opts): number => {
  const pieces = Number(opts.quantity)
  const height = Number(opts.height)
  const length = Number(opts.length)
  const width = Number(opts.width)
  const volume = ((Number(pieces) * height * length * width) / 1728).toFixed(2)

  return Number(volume)
}

const getDensity = (opts: Opts, volume: number): number => {
  if (volume <= 0) return 0

  const weight = Number(opts.weight)
  const density = (weight / volume).toFixed(2)

  return Number(density)
}

function getClassEstimate(density: number): FreightClass {
  if (density < 1) return 400
  if (density < 2) return 300
  if (density < 4) return 250
  if (density < 6) return 175
  if (density < 8) return 125
  if (density < 10) return 100
  if (density < 12) return 92.5
  if (density < 15) return 85
  if (density < 22.5) return 70
  if (density < 30) return 65
  if (density < 35) return 60
  if (density < 50) return 55
  return 50
}
